<template>
  <div id="app">

    <ReactiveBase
      class=""
      v-bind:app="appindex"
      v-bind:url="appurl"
    >


      <div class="container">

      <div class="mt-1 mr-0 mb-2 ml-4">
      <div class="inline">
        <DataSearch
          componentId="TitleContents"
          :highlightField="['report_contents']"
          :autosuggest="false"
          :highlight="true"
          iconPosition="left"
          :innerClass="{
             title: 'text-title',
             input: 'rounded'
          }"
          :dataField="[
            'report_subtitle',
            'report_title',
            'report_contents'
          ]"
          className=""
          filterLabel="Term"
          :showClear="true"
          queryFormat="and"
          :fieldWeights="[3, 3, 3]"
          placeholder="Search"
          :showFilter="false"
          :customHighlight="customHighlight"
          :URLParams="true"

      />
      </div>
<!--       <button @click="downloadWithAxios">Download</button> -->
      </div>
<div class="flex flex-row pt-1 pr-1 pb-1 pl-4 mb-2 mr-0 justify-between">
<!--
<template>
    <selected-filters />
</template>
</div>
-->
         <div class="mt-0">

             <multi-dropdown-list
                 componentId="DateRange"
                 sortBy="asc"
                 :showFilter="true"
                 filterLabel="Date"
                 class="mr-4 pt-1 pb-1 flex items-center"
                 :showMissing="false"
                 selectAllLabel="Any"
                 :size="20"
                 :innerClass="{
                    title: '!font-bold !text-lg !mr-1',
                    list: 'filter-list !text-xs !rounded',
                    icon: '',
                    count: '',

                    input: '',
                    label: '',
                    checkbox: '',
                    select: '!w-40 !pt-1 !pr-1 !pb-1 !pl-3 inline-flex !rounded !bg-yellow-100 !text-gray-700'
                 }"
                 dataField="report_date_range"
                 :transformData="orderDateRange"
                 title="Date"
                 :showSearch="false"
                 :react="{ and: ['TitleContents','ReportType','LayerId'] }"
             />
         </div>

         <div>
             <multi-dropdown-list
                 componentId="LayerId"
                 :showFilter="true"
                 filterLabel="Area"
                 class="mr-4 pt-1 pb-1 flex items-center"
                 :innerClass="{
                    title: '!font-bold !text-lg !mr-1',
                    list: 'filter-list !text-xs !rounded',
                    icon: '',
                    count: '',

                    input: '',
                    label: '',
                    checkbox: '',
                    select: '!w-40 !pt-1 !pr-1 !pb-1 !pl-3 inline-flex !rounded !bg-yellow-100 !text-gray-700'
                 }"
                 dataField="layer_id"
                 title="Area"
                 selectAllLabel="Any"
                 :showSearch="false"
                 :react="{ and: ['TitleContents','DateRange','ReportType'] }"
                 :URLParams="true"
             />
         </div>

         <div>
             <multi-dropdown-list
                 componentId="ReportType"
                 sortBy="asc"
                 :showFilter="true"
                 filterLabel="Type"
                 selectAllLabel="Any"
                 :showMissing="false"
                 class="pt-1 pb-1 flex items-center"
                 :innerClass="{
                    title: '!font-bold !text-lg !mr-1',
                    list: 'filter-list !text-xs !rounded',
                    icon: '',
                    count: '',

                    input: '',
                    label: '',
                    checkbox: '',
                    select: '!w-40 !pt-1 !pr-1 !pb-1 !pl-3 inline-flex !rounded !bg-yellow-100 !text-gray-700'
                 }"
                 dataField="report_type"
                 title="Type"
                 :showSearch="false"
                 :react="{ and: ['TitleContents','DateRange','LayerId'] }"
                 :URLParams="true"
             />
         </div>


         </div>

        <ReactiveList
          componentId="SearchResult"
          listClass="mt-5"
          dataField="report_date"
          :pagination="true"
          :pages="10"
          :from="0"
          :size="20"
          @queryChange="onQueryChange"
          :defaultQuery="listsort"
          :react="{ and: ['LayerId','TitleContents','DateRange','ReportType'] }"
          :sortOptions="[{label: 'Sorted by Relevance', dataField: '_score', sortBy: 'desc'},{label: 'Sorted by Date', dataField: 'report_date', sortBy: 'desc'}]"
          :innerClass="{
             resultsInfo: 'ml-5 text-base',
             sortOptions: 'result-sort-options !rounded'
          }"
        >

        <div slot="renderData" class="mb-4 ml-4 pr-1 pb-4 pl-1 border-b-4 last:border-b-0" slot-scope="{ item }">
            <div class="flex justify-between font-bold text-lg">
                <div>{{item.report_type}} </div>
                <div><span class="font-normal whitespace-nowrap">{{item.report_date}}</span></div>
            </div>
 
             <div class="font-bold text-lg hover:text-red-700 mt-2">
                <a v-bind:href="item.report_url">
                    <span v-html="item.report_title"></span>
                </a>
            </div>
  
            <template v-if="typeof(item.highlight.report_contents)!=='undefined'">
            <div class="pb-5" v-if="typeof(item.highlight.report_contents[0])!=='undefined'">
                 ... <span v-html="item.highlight.report_contents[0]"></span> ...
             </div>
            </template>
            <div class="pt-1 mt-2" v-else>{{trimContent(item.report_title,item.report_contents)}} ...</div>
        </div>


        </ReactiveList>

      </div>

    </ReactiveBase>

  </div>

</template>

<script>
import axios from 'axios'
import './styles.css'

export default {
  name: 'app',
  data: function () {
    return {
      showBooks: window.innerWidth <= 768,
      currentQueryString: null,
      appurl: process.env.VUE_APP_URL + "es/",
      appindex: process.env.VUE_APP_INDEX
    }
  },
  methods: {
    onQueryChange: function(before, after) {
       this.currentQueryString = JSON.stringify(after); 

       // when sorting by score need to sort by report_date within score; also see default qurey
       if (after.sort.length == 1 && typeof after.sort[0]._score != "undefined") {
            after.sort.push({report_date: {order: "desc"}});
       }
    },
    trimContent: function (title, contents) {
       if (contents === null) return null
       return contents.replace(title, '').replace(title, '').substring(0,250);
    },
    customHighlight: function () {
      return {
        'highlight': {
            'pre_tags': [
                '<mark>'
            ],
            'post_tags': [
                '</mark>'
            ],
            'order':'score',
            'fields': {
                'report_contents': { 'fragment_size': 250}
            }
        }
      }
    },
    listsort: function () {
      return {
        'sort': [
          {'_score': 'desc'},
          {'report_date': 'desc'}
        ],
        'query': {
          'match_all': {}
        }
      }
    },
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'searchoutput.txt') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    jsonToCSV: function(arg) {
        var result = "score\treport_title\turl\treport_date\n";
        for (var i=0; i<arg.hits.hits.length; i++) {
           var cur=arg.hits.hits[i];
           result+=cur._score + "\t" + cur._source.report_title + "\t" + cur._source.report_url + "\t" + 
            cur._source.report_date + "\n";
        }
        return result
    },
    downloadWithAxios(){
      var mydata =  JSON.parse(this.currentQueryString)
      mydata._source.excludes=['report_contents'] // for performance 
      mydata.size=10000 // get everything, not just one page; I believe 10,000 is standard max ES result size
      axios({
        method: 'post',
        url: process.env.VUE_APP_URL + "es/" + process.env.VUE_APP_INDEX + "/_search",
        data: mydata
      })
      .then(response => {
        var csv=this.jsonToCSV(response.data)
        this.forceFileDownload(csv)
      })
      // eslint-disable-next-line
      .catch(() => console.log('error occured'))
    },

    orderDateRange: function (arg) {
        var result = []
        arg.forEach(function(x) {result.push({'key':x.key, 'doc_count':x.doc_count})}) // copy
        result.sort(function(a,b) { return a.key<b.key ? -1 : 1})
        for (var i=0; i<result.length; i++) {
            if (result[i].key.includes('Earlier')) {
                result.unshift(result.splice(i,1)[0])
                break
            }
        }
        for (var j=0; j<result.length; j++) {
            if (result[j].key.includes('No')) {
                result.unshift(result.splice(j,1)[0])
                break
            }
        }
        result.reverse()
        return result
    },
    switchContainer: function () {
      return (this.showBooks = !this.showBooks)
    }
  }
}

</script>

